import { render, staticRenderFns } from "./IncidentFieldGroup.vue?vue&type=template&id=17782738&scoped=true&"
import script from "./IncidentFieldGroup.vue?vue&type=script&lang=js&"
export * from "./IncidentFieldGroup.vue?vue&type=script&lang=js&"
import style0 from "./IncidentFieldGroup.vue?vue&type=style&index=0&id=17782738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17782738",
  null
  
)

export default component.exports
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCardSection,QItemSection,QList,QItem});
